import { ApiError, createAction } from 'redux-api-middleware';
import { HTTP_CONTENT_TYPE_HEADER, HTTP_CONTENT_TYPE_JSON, HTTP_POST } from './ApiAction';

export const SUBMIT_FEEDBACK = 'barmer-bonus-shared/feedback/SUBMIT' as const;
export const SUBMIT_FEEDBACK_SUCCESS = 'barmer-bonus-shared/feedback/SUCCESS' as const;
export const SUBMIT_FEEDBACK_FAILURE = 'barmer-bonus-shared/feedback/FAILURE' as const;
export const SUBMIT_FEEDBACK_DONE = 'barmer-bonus-shared/feedback/DONE' as const;

export type SubmitFeedback = { type: typeof SUBMIT_FEEDBACK; payload: Feedback };
export type SubmitFeedbackSuccess = { type: typeof SUBMIT_FEEDBACK_SUCCESS };
export type SubmitFeedbackFailure = {
  type: typeof SUBMIT_FEEDBACK_FAILURE;
  payload?: ApiError;
  error: boolean;
};
export type SubmitFeedbackDone = { type: typeof SUBMIT_FEEDBACK_DONE };

export type Action =
  | SubmitFeedback
  | SubmitFeedbackSuccess
  | SubmitFeedbackFailure
  | SubmitFeedbackDone;

export const SUBMIT_FEEDBACK_STATE_IDLE = 'idle' as const;
export const SUBMIT_FEEDBACK_STATE_SUBMITTING = 'submitting' as const;
export const SUBMIT_FEEDBACK_STATE_SUCCESS = 'success' as const;
export const SUBMIT_FEEDBACK_STATE_FAILURE = 'failure' as const;

export type SubmitFeedbackState =
  | typeof SUBMIT_FEEDBACK_STATE_IDLE
  | typeof SUBMIT_FEEDBACK_STATE_SUBMITTING
  | typeof SUBMIT_FEEDBACK_STATE_SUCCESS
  | typeof SUBMIT_FEEDBACK_STATE_FAILURE;

export type Feedback = {
  comment: string;
  contact?: string;
  contactRequested?: boolean;
};

export type State = {
  uploadState: SubmitFeedbackState;
  error?: ApiError;
};

const initialState: State = {
  uploadState: SUBMIT_FEEDBACK_STATE_IDLE,
  error: undefined,
};

export default function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case SUBMIT_FEEDBACK:
      return {
        ...state,
        uploadState: SUBMIT_FEEDBACK_STATE_SUBMITTING,
      };
    case SUBMIT_FEEDBACK_SUCCESS:
      return {
        ...state,
        uploadState: SUBMIT_FEEDBACK_STATE_SUCCESS,
      };
    case SUBMIT_FEEDBACK_FAILURE:
      return {
        ...state,
        uploadState: SUBMIT_FEEDBACK_STATE_FAILURE,
        error: action.error ? action.payload : undefined,
      };
    case SUBMIT_FEEDBACK_DONE:
      return initialState;
    default:
      return state;
  }
}

export const submitFeedback = (feedback: Feedback) =>
  createAction({
    endpoint: '/feedback',
    types: [
      { type: SUBMIT_FEEDBACK, payload: feedback },
      SUBMIT_FEEDBACK_SUCCESS,
      SUBMIT_FEEDBACK_FAILURE,
    ],
    method: HTTP_POST,
    headers: { [HTTP_CONTENT_TYPE_HEADER]: HTTP_CONTENT_TYPE_JSON },
    body: JSON.stringify(feedback),
  });

export const submitFeedbackDone = (): Action => ({
  type: SUBMIT_FEEDBACK_DONE,
});
